import jwtDecode from 'jwt-decode'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import app from '../../../app'
import Button from '../../../common/common/button/button'
import IntlMessage from '../../../common/common/intl/intl_message'
import moment from 'moment'
import { XERO_LOGIN_URL } from '../../../lib/constants'

const H3 = styled.h3`
  font-family: "LeagueGothicRegular", georgia, times, serif;
  font-size: 1.875rem;
  font-weight: 500;
  margin-bottom: 1rem;
  text-transform: uppercase;
`

const Panel = styled.div`
  background-color: white;
  box-shadow: rgb(20 50 51 / 10%) 0 2px 1px 0;
  margin-bottom: 1.5rem;
  padding: 3.125rem;
`

const XeroDetail = styled.table`
  color: #514947;
  font-family: "OpensansLight", Arial, helvetica, sans-serif;

  td, th {
    padding-bottom: 0.25rem;
  }

  th {
    font-weight: bold;
    text-align: left;
    padding-right: 0.5rem;
  }
`

const XeroIntegration = () => {
  const [xeroIntegration, setXeroIntegration] = useState(null)
  const [authenticatedOn, setAuthenticatedOn] = useState('')
  const [xeroUsername, setXeroUsername] = useState('')

  useEffect(() => {
    const xero = app.getTeam()?.integration?.xero || null
    setXeroIntegration(xero)
  }, [])

  useEffect(() => {
    if (!xeroIntegration) return
    const idToken = jwtDecode(xeroIntegration.tokenSet.id_token)
    setXeroUsername(idToken.email)

    const accessToken = jwtDecode(xeroIntegration.tokenSet.access_token)
    const date = moment.unix(accessToken.auth_time).format('D MMM YYYY, h:mm a')
    setAuthenticatedOn(date)
  }, [xeroIntegration])

  const invokeXeroLogin = () => {
    const query = [
      `returnURL=${window.location.href}`,
      `teamID=${app.getTeamId()}`,
      `userID=${app.getUser().id}`
    ]

    window.location.href = `${XERO_LOGIN_URL}?${query.join('&')}`
  }

  const invokeXeroDisconnect = async () => {
    const teamID = app.getTeamId()
    const integration = app.getTeam()?.integration
    const { xero, ...restIntegration } = integration

    try {
      await app.service('/api/team').patch(teamID, { integration: restIntegration })
      setXeroIntegration(null)
    } catch (error) {
      app.logger.error(error)
    }
  }

  return (
    <Panel>
      <H3><IntlMessage ident='setting.xero_integration.xero_integration' /></H3>
      {xeroIntegration
        ? (
          <>
            <XeroDetail>
              <tbody>
                <tr>
                  <th><IntlMessage ident='setting.xero_integration.tenant_name' /> :</th>
                  <td>{xeroIntegration.tenant.name}</td>
                </tr>
                <tr>
                  <th><IntlMessage ident='setting.xero_integration.account_username' /> :</th>
                  <td>{xeroUsername}</td>
                </tr>
                <tr>
                  <th><IntlMessage ident='setting.xero_integration.authenticated_on' /> :</th>
                  <td>{authenticatedOn}</td>
                </tr>
                <tr>
                  <td colSpan='2'>
                    <br />
                    <Button
                      className='button_save'
                      canHover={false}
                      title='setting.xero_integration.xero_disconnect'
                      type='button'
                      onClick={invokeXeroDisconnect}
                    />
                  </td>
                </tr>
              </tbody>
            </XeroDetail>
          </>
        )
        : (
          <Button
            className='button_save'
            canHover={false}
            title='setting.xero_integration.connect_to_xero'
            type='button'
            onClick={invokeXeroLogin}
          />
        )}
    </Panel>
  )
}

export { XeroIntegration }
